<template>
  <div
    class="position-absolute left-container"
    :style="{ height: height, top: top, width: '388px!important', overflow: `visible !important` }"
  >
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-b-5px">材质编辑</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>
    <el-form ref="materialForm" :model="formData" label-width="90px">
      <el-form-item label="节点名称/编码" prop="nodeName">
        <div class="flex items-center">
          <el-input
            placeholder="请拾取选中节点"
            size="small"
            class="mr-10px"
            style="pointer-events: none"
            v-model="formData.nodeName"
          ></el-input>
          <el-button size="small" type="primary" @click="pickNode">
            <i class="iconfont icon-yxr-move text-16px"></i>
          </el-button>
        </div>
      </el-form-item>
      <el-form-item v-if="formData.node" label="透明度" prop="alpha">
        <el-slider
          show-input
          v-model="formData.alpha"
          :min="0"
          :max="1"
          :step="0.1"
          @change="
            (val) => {
              materialChange(val, 'alpha')
            }
          "
        ></el-slider>
      </el-form-item>
      <el-form-item v-if="formData.node" label="光泽度" prop="shininess">
        <el-slider
          show-input
          v-model="formData.shininess"
          :min="0"
          :max="1"
          :step="0.1"
          @change="
            (val) => {
              materialChange(val, 'shininess')
            }
          "
        ></el-slider>
      </el-form-item>
      <el-form-item v-if="formData.node" label="漫反射" prop="diffuse">
        <el-color-picker
          v-model="formData.diffuse"
          color-format="hex"
          size="small"
          @change="
            (val) => {
              materialChange(val, 'diffuse')
            }
          "
        ></el-color-picker>
      </el-form-item>
      <el-form-item v-if="formData.node" label="粗糙度" prop="roughness">
        <el-slider
          show-input
          v-model="formData.roughness"
          :min="0"
          :max="1"
          :step="0.1"
          @change="
            (val) => {
              materialChange(val, 'roughness')
            }
          "
        ></el-slider>
      </el-form-item>
      <el-form-item v-if="formData.node" label="金属度" prop="metallic">
        <el-slider
          show-input
          v-model="formData.metallic"
          :min="0"
          :max="1"
          :step="0.1"
          @change="
            (val) => {
              materialChange(val, 'metallic')
            }
          "
        ></el-slider>
      </el-form-item>
      <div class="flex justify-center" v-if="formData.node">
        <el-button size="mini" type="primary" @click="saveMaterial">保存</el-button>
        <el-button size="mini" type="primary" class="i-ml-20px" @click="restoreMaterial"
          >重置</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditTextureVk',
  components: {},
  props: {
    player: {
      type: Object,
    },
    height: {
      type: String,
      default: '50rem',
    },
    top: {
      type: String,
      default: '6.6rem',
    },
  },
  data() {
    return {
      currentSave: false, // 变更后是否保存
      formData: {
        node: null,
        nodeName: '',
        alpha: 0,
        shininess: 0,
        diffuse: 0,
        roughness: 0,
        metallic: 0,
      },
    }
  },
  watch: {},
  methods: {
    closeComponents() {
      this.$emit('closeComponents', 'EditTexture')
    },
    async restoreMaterial() {
      const materialInfo = sessionStorage.getItem(this.formData.node)
      let info = {}
      if (materialInfo) {
        info = JSON.parse(materialInfo)
      } else {
        info = { ...this.formData }
      }
      if (info.originalMaterial) {
        // await this.player.Native.Node.removeFromFactory([info.node])
        await this.player.Native.Node.setProperty(info.node, {
          material: info.originalMaterial,
          // geometry: info.originalGeometry,
        })
        // await this.player.Native.Node.addToFactory([info.node])
      }
      this.formData = this.$options.data().formData
      // 重置节点后，重新拾取，达到初始化目的
      this.pickNode()
    },
    // 材质属性变更
    async materialChange(val, attribute) {
      if (attribute === 'diffuse') {
        const color = parseInt(`${val.split('#')[1]}FF`, 16)
        this.player.Native.Material.setProperty(this.formData.curMaterial, {
          [attribute]: color,
        })
      } else {
        this.player.Native.Material.setProperty(this.formData.curMaterial, {
          [attribute]: val,
        })
      }
      this.currentSave = false
    },
    // 拾取选中节点,并初始化材质信息
    async pickNode() {
      if (this.formData.node && this.formData.originalMaterial && !this.currentSave) {
        // 切换节点情况，且上一个节点有变动，则还原上一节点最近一次pickup的状态，再pick下一个节点
        // await this.player.Native.Node.removeFromFactory([this.formData.node])
        await this.player.Native.Node.setProperty(this.formData.node, {
          material: this.formData.originalMaterial,
          // geometry: this.formData.originalGeometry,
        })
        // await this.player.Native.Node.addToFactory([this.formData.node])
        this.formData = this.$options.data().formData
      }
      this.currentSave = false
      const tempNode = await this.player.Native.Node.getSeletedNodes()
      if (tempNode?.length) {
        const nodeInfo = await this.player.Native.Node.getProperty(tempNode[0], [
          'name',
          'code',
          'material',
          'geometry',
        ])
        if (!nodeInfo.material) {
          this.$message.warning('当前节点无材质,请重新选择')
          return
        }
        const geo = await this.player.Native.PrjFunc.calcUVForGeometry(nodeInfo.geometry)
        const newMaterial = await this.player.Native.Material.clone(nodeInfo.material)
        const materialInfo = await this.player.Native.Material.getProperty(newMaterial, [
          'name',
          'code',
          'alpha',
          'shininess',
          'diffuse',
          'roughness',
          'metallic',
        ])
        materialInfo.diffuse = this.intToHex(materialInfo.diffuse)
        Object.assign(this.formData, {
          ...materialInfo,
          curMaterial: newMaterial,
          originalMaterial: nodeInfo.material,
          originalGeometry: nodeInfo.geometry,
          node: nodeInfo.node,
          nodeName: nodeInfo.name || nodeInfo.code,
          geometry: geo,
        })
        this.currentSave = false
        await this.player.Native.Node.setProperty(tempNode[0], {
          material: newMaterial,
        })
        this.player.Native.Camera.moveToNode(tempNode[0], 2, 0)
      } else {
        this.$message.warning('无选中节点')
      }
    },
    // 十进制int类型颜色，转为hex
    intToHex(color) {
      const hexString = color.toString(16).toUpperCase()
      return `#${hexString.substr(0, 6)}`
    },
    saveMaterial() {
      const materialInfo = sessionStorage.getItem(this.formData.node)
      if (!materialInfo) {
        // 保存的是模型最原始的材质，存一次即可
        const data = _.pick(this.formData, ['node', 'originalMaterial', 'originalGeometry'])
        sessionStorage.setItem(this.formData.node, JSON.stringify(data))
      }
      this.currentSave = true
      this.$message.success('保存成功')
    },
  },
  async mounted() {
    // 关闭拾取到code，避免点选节点大部分没有材质
    this.player.Native.Setting.set('func.pickupToCode', false)
  },
  async beforeDestroy() {
    // 重新开启拾取code
    this.player.Native.Setting.set('func.pickupToCode', true)
    if (this.formData.node && this.formData.originalMaterial && !this.currentSave) {
      // 当前node未保存，优先还原到最近一次打开，
      // await this.player.Native.Node.removeFromFactory([this.formData.node])
      await this.player.Native.Node.setProperty(this.formData.node, {
        material: this.formData.originalMaterial,
        // geometry: this.formData.originalGeometry,
      })
      // await this.player.Native.Node.addToFactory([this.formData.node])
      this.formData = this.$options.data().formData
    }
  },
}
</script>
<style lang="scss">

@import '../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../css/component.scss';
/deep/.el-row {
  align-items: center;
}
.text-color-white {
  color: white;
}
.position-absolute {
  position: absolute;
}
.fz-12 {
  font-size: 12px;
}
.fz-14 {
  font-size: 14px;
}
.m-t-2px {
  margin-top: 2px;
}
.m-t-10px {
  margin-top: 10px;
}
.m-t-5px {
  margin-top: 5px;
}
.mr-10px {
  margin-left: 10px;
}
.flex {
  display: flex;
}
.i-ml-20px {
  margin-left: 20px !important;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
/deep/ .el-form-item__label {
  color: #fff;
}
/deep/ .el-form {
  max-height: 510px;
  overflow-y: auto;
  padding: 10px;
  &::-webkit-scrollbar {
    width: 3px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #1b5b92d3; // 主色，可根据需要调整
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    background: #11416b6e;
    border-radius: 2px;
  }
}
/deep/ .el-input-number__decrease {
  width: 24px !important;
}
/deep/ .el-form-item {
  margin-bottom: 15px;
}
/deep/ .el-slider__input {
  width: 96px !important;
}
/deep/ .el-slider__input .el-input__inner {
  min-width: 0 !important;
  width: 100% !important;
  padding: 0 32px !important;
}

/deep/.el-slider__runway {
  background: linear-gradient(90deg, hsla(0, 0%, 100%, 0) 0, #fff);
}

/deep/ .el-slider__runway.show-input {
  margin-right: 110px;
}
/deep/ .el-button {
  background-color: #00c0ff !important;
}
.text-16px {
  font-size: 16px;
}

</style>
